var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.094 18.076H5.906a1.34 1.34 0 0 1-.928-.368 1.228 1.228 0 0 1-.384-.888V5.521h11.812v11.3c0 .332-.138.652-.384.887a1.34 1.34 0 0 1-.928.368ZM8.531 14.31V9.287m3.938 5.023V9.287m-10.5-3.766H19.03",
    stroke: "currentColor",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.469 3.01H8.53c-.348 0-.682.133-.928.368a1.228 1.228 0 0 0-.384.888v1.256h6.562V4.266a1.23 1.23 0 0 0-.384-.888 1.343 1.343 0 0 0-.928-.367Z",
    stroke: "currentColor",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fc2775b3c1d26135f78613a7afb6ec9d.svg";
export { ForwardRef as ReactComponent };